import React, { useEffect, useState } from "react";
import axios from "axios";
import { CKYCUploadFileWithName } from "./CKYCUploadFileWithName";
import "./CKYC.css";
import { baseUrl } from "../index";

const RelationOption = [
  { Key: "Father", Value: "FatherName" },
  { Key: "Mother", Value: "MotherName" },
  { Key: "Spouse", Value: "SpouseName" },
];

const DocTypeUpload = (props) => {
  const [Base64Photo, setBase64Photo] = useState("");
  const [Base64POI, setBase64POI] = useState("");
  const [Base64POA, setBase64POA] = useState("");
  const [selectedPOA, setSelectedPOA] = useState("");
  const [selectedPOI, setSelectedPOI] = useState("");
  const [selectedPOIValue, setSelectedPOIValue] = useState("");
  const [selectedPOAValue, setSelectedPOAValue] = useState("");
  const [Relation, setRelation] = useState("FatherName");
  const [RelationName, setRelationName] = useState("");

  useEffect(() => {
    const ckycData = Array.isArray(props.CKYCData) ? props.CKYCData : [];
    setSelectedPOI(ckycData.filter((row) => row.name?.match("PAN"))[0]?.name || "");
    setSelectedPOA(ckycData.filter((row) => row.name?.match("ADHAR"))[0]?.name || "");
  }, [props.CKYCData]);

  const onSubmit = (e) => {
    e.preventDefault();
    if (props.Companyid === 118 && RelationName.trim() === "") {
      return alert(`Kindly Enter ${Relation} Name`);
    }

    const files = document.querySelectorAll("input[type=file]");
    const formData = new FormData();
    formData.append("insurerID", props.Companyid);
    formData.append("enquiryNo", props.EnquiryNo);
    formData.append("URL", "UploadCKYCFile");

    files.forEach((f) => {
      if (f.value !== "") formData.append(f.id?.toLowerCase(), f.files[0]);
    });

    axios
      .post(`${baseUrl}/services/call/UploadFile`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        if (res.data.StatusCode === 200) {
          const ckycData = Array.isArray(props.CKYCData) ? props.CKYCData : [];
          const kycDetails = {
            Base64Photo,
            Base64POI,
            Base64POA,
            IsRedirectUrl: false,
            IsUploadFile: true,
            Relation: RelationName + "~" + Relation,
            SelectedPOA: ckycData.filter((row) => row.Name === selectedPOA)[0]?.Code,
            SelectedPOI: ckycData.filter((row) => row.Name === selectedPOI)[0]?.Code,
            SelectedPOIValue: selectedPOIValue,
            selectedPOAValue: selectedPOAValue,
          };
          props.setKYCDetails(kycDetails);
          props.onUploadSuccess?.(kycDetails);
        } else {
          alert("Kindly Choose File");
        }
      });
  };

  const ckycData = Array.isArray(props.CKYCData) ? props.CKYCData : [];
  const canUpload = Base64POA !== "" && Base64POI !== "";

  const shellStyle = {
    display: "block",
    position: "relative",
    background:
      "radial-gradient(circle at top left, rgba(14, 97, 117, 0.18), transparent 28%), linear-gradient(180deg, #f6fbfc 0%, #ffffff 45%, #eef7f9 100%)",
  };
  const dialogStyle = {
    maxWidth: "1120px",
    width: "calc(100% - 28px)",
    margin: "24px auto",
  };
  const contentStyle = {
    border: "0",
    borderRadius: "26px",
    overflow: "hidden",
    boxShadow: "0 28px 80px rgba(15, 42, 52, 0.28)",
    background: "#fff",
  };
  const heroStyle = {
    padding: "26px 28px",
    background: "linear-gradient(135deg, #0d3b4a 0%, #116c78 55%, #17a0a5 100%)",
    color: "#fff",
  };
  const bodyStyle = {
    padding: "22px 28px 28px",
    background: "#fbfefe",
  };
  const gridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: "18px",
  };
  const cardStyle = {
    borderRadius: "22px",
    border: "1px solid rgba(14, 97, 117, 0.1)",
    boxShadow: "0 18px 40px rgba(15, 42, 52, 0.06)",
    background: "linear-gradient(180deg, #ffffff 0%, #f6fbfc 100%)",
    padding: "20px",
  };
  const footerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    marginTop: "22px",
    paddingTop: "18px",
    borderTop: "1px solid rgba(14, 97, 117, 0.1)",
  };

  return (
    <div
      className="modal fade AnuthorModal show"
      id="exampleModalDefault33"
      style={shellStyle}
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-xl" style={dialogStyle}>
        <div className="modal-content CkycUploadDOC CkycUploadDOC002 ckyc-premium-modal" style={contentStyle}>
          <div className="ckyc-modal-hero" style={heroStyle}>
            <div className="ckyc-modal-hero__badge">CKYC Verification</div>
            <div className="ckyc-modal-hero__title">Upload POI and POA Documents</div>
            <div className="ckyc-modal-hero__sub">
              Complete the verification in a polished, secure upload flow and continue your proposal.
            </div>
          </div>

          <div className="modal-header d-flex ckyc-premium-header">
            <div>
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Upload Documents
              </h1>
              <p className="ckyc-modal-note">
                Please keep your PAN and address proof ready.
              </p>
            </div>
            <button className="CRoss" onClick={() => props.onKYCSubmit(false)}>
              X
            </button>
          </div>

          <div className="modal-body ckyc-premium-body" style={bodyStyle}>
            <div className="ckyc-upload-grid" style={gridStyle}>
              <div className="ckyc-upload-card" style={cardStyle}>
                <div className="ckyc-upload-card__top">
                  <span className="ckyc-step-pill">Step 1</span>
                  <span className="ckyc-doc-tag">Identity</span>
                </div>
                <CKYCUploadFileWithName
                  DocumentTypeID={selectedPOI}
                  setDocumentType={(data) => setSelectedPOI(data)}
                  setDocumentID={(data) => setSelectedPOIValue(data)}
                  DocumentIDValue={selectedPOIValue}
                  setDocumentBase64={(data) => setBase64POI(data)}
                  DocumentBase64={Base64POI}
                  title="Identity"
                  CKYCData={ckycData}
                />
              </div>

              <div className="ckyc-upload-card" style={cardStyle}>
                <div className="ckyc-upload-card__top">
                  <span className="ckyc-step-pill">Step 2</span>
                  <span className="ckyc-doc-tag">Address</span>
                </div>
                <CKYCUploadFileWithName
                  DocumentTypeID={selectedPOA}
                  setDocumentType={(data) => setSelectedPOA(data)}
                  setDocumentID={(data) => setSelectedPOAValue(data)}
                  DocumentIDValue={selectedPOAValue}
                  setDocumentBase64={(data) => setBase64POA(data)}
                  DocumentBase64={Base64POA}
                  title="Address"
                  CKYCData={ckycData}
                />
              </div>
            </div>

            {props.Companyid === 118 && (
              <div className="ckyc-relation-card" style={{ marginTop: "18px" }}>
                <div className="ckyc-relation-card__title">
                  Nominee Relation Details
                </div>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="ckyc-field-label">Relation Type</label>
                    <select
                      className="packageForm ckyc-field"
                      value={Relation}
                      onChange={(e) => setRelation(e.target.value)}
                    >
                      {RelationOption.map((r, i) => (
                        <option key={i} value={r.Value}>
                          {r.Key}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="ckyc-field-label">Relation Name</label>
                    <input
                      className="packageForm ckyc-field"
                      type="text"
                      value={RelationName}
                      onChange={(e) => setRelationName(e.target.value)}
                      placeholder="Enter nominee name"
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="ckyc-upload-footer" style={footerStyle}>
              <div className="ckyc-upload-footer__hint">
                <span className="ckyc-dot" />
                Upload clear images for fast CKYC approval
              </div>
              <button className="fileUploadBtn ckyc-submit-btn" disabled={!canUpload}>
                Upload Document
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocTypeUpload;
